export const ORIGIN_GROUP_ID = `origin-group-id`;
export const ORIGIN_ELEMENT_IDS = [
  ORIGIN_GROUP_ID,
  'origin-point',
  'x-axis',
  'y-axis',
  'x-axis-arrow-leg-a',
  'x-axis-arrow-leg-b',
  'y-axis-arrow-leg-a',
  'y-axis-arrow-leg-b',
] as const;

export const LINE_STROKE_WIDTH = 10;
export const ORIGIN_HEX_COLOR = '#000';

export const OriginElementSizing = {
  // Base sizing is relative to this zoom level
  REFERENCE_ZOOM: 100,
  // Sizes
  AXIS_LINE_LENGTH: 800,
  ARROW_LEG_LENGTH: 70,
  CIRCLE_RADIUS: 80,
};
